import * as types from '../mutation-types'
import Vue from 'vue'

// initial state
const state = {
  sportForecastLang: null,
  sportForecastToggle: false,
  sportForecastWindowEvent: null,
  sportForecastSelectedEvent: null,
  sportForecastList: null,
  sportWaitingWagerList: null,
}

// getters
const getters = {
  sportForecastLang: state => state.sportForecastLang,
  sportForecastToggle: state => state.sportForecastToggle,
  sportForecastWindowEvent: state => state.sportForecastWindowEvent,
  sportForecastSelectedEvent: state => state.sportForecastSelectedEvent,
  sportForecastList: state => state.sportForecastList,
  sportWaitingWagerList: state => state.sportWaitingWagerList,
}

// actions
const actions = {
  removeSportForecastList(context, payload){
    var sportForecastList = this.getters.sportForecastList
    Vue.delete(sportForecastList[payload.eveid][payload.ftPlyType][payload.bettypKey], payload.tbetKey)
    //if bettype empty
    if(Object.keys(sportForecastList[payload.eveid][payload.ftPlyType][payload.bettypKey]).length == 0) {
      Vue.delete(sportForecastList[payload.eveid][payload.ftPlyType], payload.bettypKey)
      //if playtype empty
      if(Object.keys(sportForecastList[payload.eveid][payload.ftPlyType]).length == 0) {
        Vue.delete(sportForecastList[payload.eveid], payload.ftPlyType)
        //if event empty
        if(Object.keys(sportForecastList[payload.eveid]).length == 1) {
          Vue.delete(sportForecastList, payload.eveid)
          //if forecast empty
          if(Object.keys(sportForecastList).length == 0) {
            sportForecastList = null
            // this.selectedForecastEvent = null
          }
        }
      }
    }
    this.commit('SPORTFORECAST_LIST', sportForecastList)
  }
}

// mutations
const mutations = {
  [types.SPORTFORECAST_LANG] (state, payload ) {
    state.sportForecastLang = payload
  },

  [types.SPORTFORECAST_TOGGLE] (state, payload ) {
    state.sportForecastToggle = payload
  },

  [types.SPORTFORECAST_WINDOWEVENT] (state, payload ) {
    state.sportForecastWindowEvent = payload
  },

  [types.SPORTFORECAST_SELECTEDEVENT] (state, payload ) {
    state.sportForecastSelectedEvent = payload
  },

  [types.SPORTFORECAST_LIST] (state, payload ) {
    state.sportForecastList = payload
  },
  [types.SPORTFORECAST_WAITINGLIST] (state, payload ) {
    state.sportWaitingWagerList = payload
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./resources/wob/vue/store/modules/forecast.js